export default "__VITE_ASSET__aeb99f16__"